﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateVehiclesTypes = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../com/tmpls");
const StatePaged_1 = require("../abstracts/StatePaged");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const gs_1 = require("@ivanlog/gs");
const StateCreateVehiclesTypes_1 = require("./StateCreateVehiclesTypes");
const AccessTypeEnum_1 = require("../../enums/AccessTypeEnum");
class StateVehiclesTypes extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageList, "Vehicles types", true);
        this.isSuperAdmin = false;
        this.page.ctrls.btnNew.onclick = () => gs_1.StateGS.Run(StateCreateVehiclesTypes_1.StateCreateVehiclesTypes);
        this.isSuperAdmin = this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.SuperAdmin);
    }
    start() {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield this.app.astra.refreshVehiclesType();
            const vtypes = yield this.app.astra.getVehiclesTypes();
            if (!vtypes)
                return;
            this.fill(vtypes);
            if (!this.isSuperAdmin)
                this.page.ctrls.btnNew.hide();
            return _super.start.call(this);
        });
    }
    fill(vtypes) {
        this.page.ctrls.list.html = '';
        for (const vtype of vtypes) {
            const item = new com.ListItem();
            item.ctrls.lType.text = "Vehicles type";
            item.ctrls.lId.text = `#${vtype.id}`;
            let data = [gs.text.clearHtmlToText(`${vtype.name.en}`), `Size: w${vtype.size.width} : l${vtype.size.length} : h${vtype.size.height}`];
            item.ctrls.pData.html = data.join('<br>');
            this.page.ctrls.list.append(item);
            if (this.isSuperAdmin)
                item.onclick = () => this.tryDelete(vtype.id, item);
            else
                item.addClass("no-active");
        }
    }
    tryDelete(id, item) {
        return __awaiter(this, void 0, void 0, function* () {
            const confirm = yield new modalCom.DialogOkNo("Delete this vehicles type and all linked entities?", "Warning").show();
            if (confirm != modalCom.ModalDialogResult.Ok)
                return;
            const responce = yield this.lockgui(this.app.api.admin.directory.deleteVehicleType(id));
            if (!responce)
                return;
            item.cut();
        });
    }
}
exports.StateVehiclesTypes = StateVehiclesTypes;
StateVehiclesTypes.StateName = "vehiclesTypes";
//# sourceMappingURL=StateVehiclesTypes.js.map